import {useCallback} from 'react';
import {type IVIntent, GUEST_FORM_NAMES} from '@chekin/core';
import {useIVStore} from '../../../store/useIVStore';
import {useUpdateIvIntent} from '../../../hooks/useUpdateIvIntent';
import type {DocumentSelectionFormTypes} from '../documentSelection/types';

type Props = {
  onSuccess?: (data: IVIntent) => void;
  goToUploading: () => void;
  getIntentId?: () => string | null | undefined;
};

export const useDocumentSelection = ({onSuccess, goToUploading, getIntentId}: Props) => {
  const {setDocumentType, setNationality} = useIVStore();

  const {sendUpdateIvIntentRequest, isLoading} = useUpdateIvIntent({
    onSuccess,
    postHandler: goToUploading,
  });

  const confirm = useCallback(
    (data: DocumentSelectionFormTypes) => {
      const docType = data?.[GUEST_FORM_NAMES.document_type]?.data;
      if (docType) {
        setDocumentType(docType);
      }
      const nationality = data[GUEST_FORM_NAMES.nationality]?.value;
      if (nationality) {
        setNationality(nationality);
      }

      const intentId = getIntentId?.();
      if (intentId && docType && nationality) {
        sendUpdateIvIntentRequest({id: intentId, nationality, type_doc: docType});
      } else {
        goToUploading();
      }
    },
    [
      getIntentId,
      goToUploading,
      sendUpdateIvIntentRequest,
      setDocumentType,
      setNationality,
    ],
  );

  return {isLoading, confirm};
};
